module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-03-b67af33d12283003acde6d3d9664d809.png";